import type { ApiError } from "../api.js";
import { useI18n } from "../i18n.js";

/**
 * Shown when the plan stops an action (the API answered 402 `plan_limit`). The message comes from billing in the account's
 * language; this only adds the button. Without an address to go to it is just the message.
 */
export function UpgradeNote({ error }: { error: ApiError }) {
  const { t } = useI18n();
  const url = typeof error.body.upgradeUrl === "string" ? error.body.upgradeUrl : null;
  return (
    <div className="banner warn upgrade" role="alert">
      <strong>{t("upgrade.title")}</strong>
      <p>{error.message}</p>
      {url && (
        <a className="btn primary" href={url}>
          {t("upgrade.cta")}
        </a>
      )}
    </div>
  );
}
